import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.animate = this.animate.bind(this);
    }
    init() {
        this.badge = document.querySelector('.cursor-badge');
        this.sections = document.querySelectorAll('.js-cursor');

        if (!this.sections.length) {
            this.badge.style.display = 'none';
            return;
        }

        this.mouseX = 0;
        this.mouseY = 0;
        this.currentX = 0;
        this.currentY = 0;
        this.currentScale = 0;
        this.targetScale = 0;
        this.hasMousePosition = false;

        document.addEventListener('mousemove', this.handleMouseMove);

        this.sections.forEach((section) => {
            section.addEventListener('mouseenter', () => {
                this.badge.textContent = section.dataset.cursorText || '';
                this.targetScale = 1;
            });
            section.addEventListener('mouseleave', () => {
                this.targetScale = 0;
            });
        });

        this.animate();
    }

    handleMouseMove(e) {
        this.mouseX = e.clientX;
        this.mouseY = e.clientY;

        if (!this.hasMousePosition) {
            this.currentX = e.clientX;
            this.currentY = e.clientY;
            this.hasMousePosition = true;

            this.badge.classList.remove('invisible');
        }
    }

    animate() {
        if (this.hasMousePosition) {
            this.currentX += (this.mouseX - this.currentX) * 0.50;
            this.currentY += (this.mouseY - this.currentY) * 0.50;
        }

        this.currentScale += (this.targetScale - this.currentScale) * 0.12;

        const offsetX = -80;
        const offsetY = -80;

        this.badge.style.transform = `translate3d(${this.currentX + offsetX}px, ${this.currentY + offsetY}px, 0) scale3d(${this.currentScale}, ${this.currentScale}, 1)`;

        this.raf = requestAnimationFrame(this.animate);
    }

    destroy() {
        document.removeEventListener('mousemove', this.handleMouseMove);

        if (this.raf) {
            cancelAnimationFrame(this.raf);
        }
    }
}